import { z } from 'zod';

/**
 * The only place `src` imports Zod (enforced in eslint.config.js). Zod compiles fast object
 * parsers with `new Function` unless told not to. The production content security policy
 * forbids that (scripts/build/hosting.ts), and even Zod's caught attempt is reported as a
 * policy violation. Every schema module takes `z` from here, so this setting is in place
 * before any schema is built, whatever order the bundle's chunks are evaluated in.
 * Validation results are the same either way; only that compiled fast path is off.
 */
z.config({ jitless: true });

export { z };
